'use client'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

// Lazy load Lottie to reduce initial bundle size (~298 KB)
const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
  loading: () => <div className="h-full w-full animate-pulse bg-gray-50" />,
})

const BackgroundLottieAnimation = ({ lottieAnimationUrl }: { lottieAnimationUrl: string }) => {
  const [animationData, setAnimationData] = useState<null>(null)

  useEffect(() => {
    fetch(lottieAnimationUrl)
      .then((data) => data.json())
      .then((json) => {
        setAnimationData(json)
      })
      .catch(() => {
        // Silently fail - Lottie animation is not critical for page functionality
      })
  }, [lottieAnimationUrl])

  if (!animationData) {
    return null
  }

  return <Lottie loop={true} animationData={animationData} className="h-full w-full" data-preserve-aspect-ratio />
}

export default BackgroundLottieAnimation
